import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameAbbreviation',
  standalone: true,
})
export class NameAbbreviationPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const parts = value.trim().split(' ');
    if (parts.length === 0) return '';

    const [first, ...rest] = parts;
    const last = rest.pop();

    const formatted = [
      this.capitalizeFirst(first),
      ...rest,
      last ? last + '.' : '',
    ].join(' ');

    return formatted;
  }

  private capitalizeFirst(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
